import { render, staticRenderFns } from "./Asegurator-medicine.vue?vue&type=template&id=295215d6&scoped=true"
import script from "./Asegurator-medicine.js?vue&type=script&lang=js&external"
export * from "./Asegurator-medicine.js?vue&type=script&lang=js&external"
import style0 from "./Asegurator-medicine.vue?vue&type=style&index=0&id=295215d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295215d6",
  null
  
)

export default component.exports